import {
  Stack,
  InputWrapper,
  TextInput,
  Select,
  Group,
  Button,
  Text,
} from "@mantine/core"
import { UseFormReturnType } from "@mantine/form"
import { IconArrowLeft, IconArrowRight } from "@tabler/icons-react"

import { DatadogDatasourceFormData } from "@costory/types/endpoints/metricsDatasources"

import { DatadogConfigSelect } from "@costory/front/pages/Datasources/components/common/DatadogConfigSelect"
import { useDatadogInstallationsQuery } from "@costory/front/queries/metricsDatasources"

export const DatadogConfiguration = ({
  form,
  handleClickBack,
  handleClickNext,
}: {
  form: UseFormReturnType<DatadogDatasourceFormData>
  handleClickBack: () => void
  handleClickNext: () => void
}) => {
  const datadogInstallationsQuery = useDatadogInstallationsQuery()

  return (
    <Stack h="100%">
      <Stack flex={1}>
        <DatadogConfigSelect form={form} query={datadogInstallationsQuery} />
        <InputWrapper
          label={
            <Text fw="bold" span={true}>
              Query
            </Text>
          }
          required
        >
          <Group>
            <Select data={["Metrics"]} value="Metrics" w="12%" />
            <TextInput
              w="86%"
              {...form.getInputProps("query")}
              placeholder="Query"
              autoComplete="on"
            />
          </Group>
        </InputWrapper>
      </Stack>
      <Group justify="space-between">
        <Button
          onClick={handleClickBack}
          variant="outline"
          leftSection={<IconArrowLeft />}
        >
          Back
        </Button>
        <Button onClick={handleClickNext} rightSection={<IconArrowRight />}>
          Next
        </Button>
      </Group>
    </Stack>
  )
}
